import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { AuctionBidStore, AuctionBidState } from './auction-bid.store';
import { AuctionBidStatus } from './auction-bid.model';

@Injectable({ providedIn: 'root' })
export class AuctionBidQuery extends QueryEntity<AuctionBidState> {
  constructor(protected store: AuctionBidStore) {
    super(store);
  }

  selectBids() {
    return this.selectAll();
  }
  selectBid(id: number) {
    return this.selectEntity(id);
  }
  selectActiveBids() {
    return this.selectAll({ filterBy: bid => bid.Status === AuctionBidStatus.Active });
  }
  selectWonBids() {
    return this.selectAll({
      filterBy: bid => {
        return bid.Status === AuctionBidStatus.Completed && bid.ItemWon;
      }
    });
  }

  selectCurrentLosingBids() {
    return this.selectAll({
      filterBy: bid => {
        return bid.Status === AuctionBidStatus.Active && !bid.ItemWon;
      }
    });
  }
}
